module.exports = __webpack_public_path__ + "static/media/phone-call.95448871.png";